import { render, staticRenderFns } from "./FormationAreaView.vue?vue&type=template&id=7b7b7da5&scoped=true"
import script from "./FormationAreaView.vue?vue&type=script&lang=js"
export * from "./FormationAreaView.vue?vue&type=script&lang=js"
import style0 from "./FormationAreaView.vue?vue&type=style&index=0&id=7b7b7da5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7b7da5",
  null
  
)

export default component.exports